import { createReduxAsyncType } from '../utils/toolkit';

const TYPES = {
  LOAD_TENANTS: createReduxAsyncType('LOAD_TENANTS'),
  LOAD_TENANT: createReduxAsyncType('LOAD_TENANT'),
  CREATE_TENANT: createReduxAsyncType('CREATE_TENANT'),
  UPDATE_TENANT: createReduxAsyncType('UPDATE_TENANT'),
  DELETE_TENANT: createReduxAsyncType('DELETE_TENANT'),
  LOAD_TENANT_ADMINS: createReduxAsyncType('LOAD_TENANT_ADMINS'),
  INVITE_TENANT_ADMIN: createReduxAsyncType('INVITE_TENANT_ADMIN'),
  RESEND_INVITE_TENANT_ADMIN: createReduxAsyncType('RESEND_INVITE_TENANT_ADMIN'),
  DELETE_TENANT_ADMIN: createReduxAsyncType('DELETE_TENANT_ADMIN'),
  LOAD_TENANT_ADMIN_DATA: createReduxAsyncType('LOAD_TENANT_ADMIN_DATA'),
  REGISTER_TENANT_ADMIN: createReduxAsyncType('REGISTER_TENANT_ADMIN'),
  LOAD_STORM360_USERS: createReduxAsyncType('LOAD_STORM360_USERS'),
  LOAD_STORM360_ADMINS: createReduxAsyncType('LOAD_STORM360_ADMINS'),
  INVITE_STORM360_ADMIN: createReduxAsyncType('INVITE_STORM360_ADMIN'),
  RESEND_INVITE_STORM360_ADMIN: createReduxAsyncType('RESEND_INVITE_STORM360_ADMIN'),
  SET_TENANT_USER_STATUS: createReduxAsyncType('SET_TENANT_USER_STATUS'),
  INVITE_TENANT_USER: createReduxAsyncType('INVITE_TENANT_USER'),
  INVITE_SHARED_USER: createReduxAsyncType('INVITE_SHARED_USER'),
  REGISTER_TENANT_USER: createReduxAsyncType('REGISTER_TENANT_USER'),
  LOAD_TENANT_PENDING_USERS: createReduxAsyncType('LOAD_TENANT_PENDING_USERS'),
  RESEND_INVITE_TENANT_USERS: createReduxAsyncType('RESEND_INVITE_TENANT_USERS'),
  DELETE_PENDING_TENANT_USERS: createReduxAsyncType('DELETE_PENDING_TENANT_USERS'),
  LOAD_PENDING_STORM360_ADMINS: createReduxAsyncType('LOAD_PENDING_STORM360_ADMINS'),
  DELETE_PENDING_STORM360_ADMINS: createReduxAsyncType('DELETE_PENDING_STORM360_ADMINS'),
  LOAD_TENANTS_FOR_SHARED_USER: createReduxAsyncType('LOAD_TENANTS_FOR_SHARED_USER'),
  ACCEPT_TENANT_INVITE: createReduxAsyncType('ACCEPT_TENANT_INVITE'),
  LOAD_TENANT_USERS_LIST: createReduxAsyncType('LOAD_TENANT_USERS_LIST'),
  UPLOAD_TENANT_LOGO: createReduxAsyncType('UPLOAD_TENANT_LOGO'),
  DELETE_TENANT_LOGO: createReduxAsyncType('DELETE_TENANT_LOGO'),
};

export { TYPES };
